export default __webpack_public_path__ + "static/media/notes-with-background.dd974daf.svg";